import store from "@/store";
import { routeData } from "@/router/constants/routes";
import { policyVehicleHasEndorsements } from "@/helpers/policy-vehicle-helper";
import { getSelectedPolicyVehicle } from "@/helpers/endorsements-helper";

export function endorsementsBeforeEnter() {
    const order = store.getters.order;
    if (order?.vehicle?.policyVehicleId == null) {
        return {
            name: routeData.POLICY_VEHICLE.name,
        };
    }

    const selectedPolicyVehicle = getSelectedPolicyVehicle(order);
    if (!policyVehicleHasEndorsements(selectedPolicyVehicle)) {
        return {
            name: routeData.POLICY_INFO_SUBMITTED.name,
        };
    }
}
